import React from "react";
import { get, isEmpty } from "lodash";
import {
  getLegacyAudioTracks,
  getLegacyNotes,
  getVersionAudioTracks,
  getVersionDateAdded,
  getVersionTimedTextTracks,
  getVersionVideoTracks,
} from "../../../utils/ContentFinderUtils";
import GeneralSection from "./GeneralSection";
import SegmentsSection from "./SegmentsSection";
import NoteSection from "./NoteSection";
import VideoSection from "./VideoSection";
import AudioSection from "./AudioSection";
import LegacyAudioSection from "./LegacyAudioSection";
import TimedTextSection from "./TimedTextSection";

const VersionDrawer = ({ meta, qmTracks, titleId }) => {
  const videoTracks = getVersionVideoTracks(meta, qmTracks);
  const videoTrack = get(videoTracks, "[0]", {});
  const videoProps = get(videoTrack, "properties", {});
  const audioTracks = getVersionAudioTracks(qmTracks);
  const legacyAudioTracks = getLegacyAudioTracks(meta);
  const timedTextTracks = getVersionTimedTextTracks(qmTracks);
  const segments = get(meta, "temporal.segments", []);
  const versionCreatedAt = getVersionDateAdded(meta);
  const legacyNotes = getLegacyNotes(meta);
  const showLegacyAudio = get(meta, "importType") && isEmpty(audioTracks);
  const showNotes = !!get(meta, "importType");

  return (
    <div className="version-drawer">
      <div className="version-drawer-top">
        <div className="version-drawer-col version-drawer-col--left">
          <GeneralSection
            meta={meta}
            videoProps={videoProps}
            titleId={titleId}
          />
        </div>
        <div className="version-drawer-col version-drawer-col--right">
          <SegmentsSection
            segments={segments}
            frameRate={get(meta, "temporal.editRate")}
          />
          {showNotes && <NoteSection notes={legacyNotes} />}
        </div>
      </div>

      <VideoSection
        videoTracks={videoTracks}
        versionCreatedAt={versionCreatedAt}
      />

      {showLegacyAudio ? (
        <LegacyAudioSection
          legacyAudioTracks={legacyAudioTracks}
          versionCreatedAt={versionCreatedAt}
        />
      ) : (
        <AudioSection audioTracks={audioTracks} />
      )}
      <TimedTextSection
        timedTextTracks={timedTextTracks}
        versionCreatedAt={versionCreatedAt}
      />
    </div>
  );
};

export default VersionDrawer;
